import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  BASE_FONT_FAMILY,
  BASE_FONT_COLOR,
  MAP_POINT_GPS_COLOR,
  MAP_POINT_WIFI_COLOR,
  MAP_POINT_CELLID_COLOR,
  BLACK
} = constants;

let styles = {
  map: {
    width: '100%',
    height: '100%'
  },
  typeSelect: {
    position: 'absolute',
    left: '50%',
    top: 10,
    zIndex: 1,
    backgroundColor: 'white',
    borderRadius: 4
  },
  superTagLegend: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: BASE_FONT_FAMILY,
    color: BASE_FONT_COLOR,
    fontSize: 12,
    position: 'absolute',
    left: 10,
    top: 10,
    zIndex: 1,
    backgroundColor: 'white',
    padding: '4px 10px 0 4px',
    borderRadius: 4
  },
  circle: {
    height: 12,
    width: 12,
    backgroundClip: 'padding-box',
    border: `2px solid ${BASE_FONT_COLOR}`,
    flexShrink: 0,
    borderRadius: 100,
    backgroundColor: BASE_FONT_COLOR
  },
  legendItem: {
    width: '100%',
    marginBottom: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  legendText: {
    width: '100%',
    marginLeft: 5
  },
  wifi: {
    backgroundColor: MAP_POINT_WIFI_COLOR,
    borderColor: BLACK
  },
  cellId: {
    backgroundColor: MAP_POINT_CELLID_COLOR,
    borderColor: BLACK
  },
  gps: {
    backgroundColor: MAP_POINT_GPS_COLOR,
    borderColor: BLACK
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/mapgl/MapGL.styles.js